export default __webpack_public_path__ + "assets/images/ef98984adbc48de34e38147701e4610c.svg";